import React, {PureComponent} from 'react'
import {DragDropContext} from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import {List, TextField} from '@material-ui/core'
import get from 'lodash/get'
import ReorderListItem from './ReorderListItem'

class ReorderList extends PureComponent {
  render() {
    return (
      <div>
        <List>
          {this.props.items.map((item, i) => (
            <ReorderListItem
              key={item.id}
              handleOnClick={() => this.props.handleOnClick(item)}
              index={i}
              id={item.id}
              text={item.value}
              isTextType={get(item, 'type', '').toLowerCase() === 'text'}
              moveListItem={this.props.moveListItem}
            />
          ))}
          {(() => {
            if (this.props.items.length < 5) {
              return (
                <TextField
                  id="Add message"
                  label="Add message"
                  type="Add message"
                  name="Add message"
                  margin="normal"
                  variant="outlined"
                  value={this.props.inputValue}
                  onChange={e => {
                    this.props.updateInputValue(e.target.value)
                  }}
                  onKeyPress={ev => {
                    if (ev.key === 'Enter') {
                      if (ev.target.value !== '') {
                        this.props.updateCustomMessage(ev.target.value)
                      }
                      ev.preventDefault()
                    }
                  }}
                />
              )
            }
            return <div />
          })()}
        </List>
      </div>
    )
  }
}

export default DragDropContext(HTML5Backend)(ReorderList)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/components/ReorderList.js